module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'vvncs8tc',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
